import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {useMemo} from 'react'
import type {ReactNode} from 'react'

export interface AnalyticsWrapperProps {
  /** The category to use for analytics events (e.g. "Issues Index", "Issues Dashboard"). */
  category: string
  children: ReactNode
  /** Application name for the analytics provider. Defaults to `"issues"`. */
  appName?: string
  /** Additional metadata to attach to analytics events. */
  metadata?: Record<string, string>
}

export function AnalyticsWrapper({children, category, appName = 'issues', metadata}: AnalyticsWrapperProps) {
  const stableMetadata = useMemo(() => metadata ?? {}, [metadata])
  return (
    <AnalyticsProvider appName={appName} category={category} metadata={stableMetadata}>
      {children}
    </AnalyticsProvider>
  )
}
